import React from 'react';
import Shimmer from '../../common/Shimmer';

const ActionCardShimmer: React.FC = () => {
  return (
    <div className="outlets-payment-card shimmer-card">
      <div className="outlets-payment-header">
        <div className="outlets-payment-title">
          <Shimmer width="18px" height="18px" borderRadius="50%" />
          <Shimmer width="220px" height="20px" />
        </div>
        <Shimmer width="120px" height="36px" className="shimmer-button" />
      </div>

      <div className="outlets-list">
        {[1, 2, 3].map((item) => (
          <div key={item} className="outlet-item">
            <Shimmer width="120px" height="18px" className="shimmer-text" />

            <div className="outlet-metrics">
              <div className="outlet-metric">
                <Shimmer width="80px" height="14px" className="shimmer-text" />
                <Shimmer width="60px" height="16px" className="shimmer-text" />
              </div>

              <div className="outlet-metric">
                <Shimmer width="100px" height="14px" className="shimmer-text" />
                <Shimmer width="70px" height="16px" className="shimmer-text" />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="outlets-payment-footer">
        <Shimmer width="140px" height="16px" />
      </div>
    </div>
  );
};

export default ActionCardShimmer;
